export const MerchantInfoMessages = {
	cardNetworkTokenizationPendingHeader:
		"Some services require additional information.",
	cardNetworkTokenizationPendingDescription:
		"Card Network Tokenization services activation is pending due missing website URL. Please update it to activate the service.",
};
